
import {
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../../features/userSlice";
import store from "../../../../store";
import { setDesignTemplatesDataTheme } from "../../../../features/themeSlice";
import { setDesignTemplatesData } from "../../../../features/templateSlice";
import { templateService } from "../../../../services/api/template.endpoints";

async function getDesignTemplates(
  oauthTokenHeader: string,
  website_shared_uid: string,
  dispatch: any
) {
  try {
    const response = await templateService.getAllTemplates(
      oauthTokenHeader,
      website_shared_uid
    );
    if (!response.status || response.status !== 200) {
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Quarterly goals', type: 'error' }))); */
    } else {
      dispatch(setDesignTemplatesData(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

//-- Duplicate function(getDesignTemplates) for get All template data and set to store(Redux)
async function getDesignTemplatesTheme(
  oauthTokenHeader: string,
  website_shared_uid: string,
  dispatch: any
) {
  try {
    const response = await templateService.getAllTemplates(
      oauthTokenHeader,
      website_shared_uid
    );
    if (!response.status || response.status !== 200) {
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Quarterly goals', type: 'error' }))); */
    } else {
      dispatch(setDesignTemplatesDataTheme(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function createDesignTemplates(oauthTokenHeader: any, data: any) {
  try {
    const response = await templateService.createTemplate(
      oauthTokenHeader,
      data
    );
    if (!response.status || response.status !== 201) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Creating Template",
          type: "error",
        })
      );
    } else {
      // store.dispatch(setDisplayErrorSnackBar({ message: 'Template Have Been Created Successfully', type: 'success' }));
      return response;
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getWidgetStructures(
  oauthTokenHeader: string,
  setWidgetStructures: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await templateService.getWidgetStructure(
      oauthTokenHeader
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    }
    setWidgetStructures(response?.data?.data); // Set the fetched data
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

async function getLabels(
  oauthTokenHeader: string,
  setLabelsContent: any,
  setErrorAccToPageStatus: any
) {
  try {
    const response = await templateService.getLabels(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      setErrorAccToPageStatus([response]);
      /* trackPromise(store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Page Content', type: 'error' }))); */
    } else {
      setLabelsContent(response?.data?.data);
    }
  } catch (e: any) {
    if (e?.status !== undefined) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Unauthorized access for label",
          type: "error",
        })
      );
    } else {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Toggle Successfull",
          type: "error",
        })
      );
    }
  }
}

/**
 * `dateRange` is optional and scopes the revisions returned with the template.
 * Callers that omit it (the existing Edit screen) are unaffected.
 */
async function getSingleDesignTemplate(
  oauthTokenHeader: string,
  templateUid: string,
  setDesignTemplatesData: any,
  setError: any,
  dateRange?: { startDate: string; endDate: string }
) {
  try {
    const response = await templateService.getSingleTemplate(
      oauthTokenHeader,
      templateUid,
      dateRange
    );
    if (!response.status || response.status !== 200) {
      // store.dispatch(setDisplayErrorSnackBar({ message: 'Something went wrong while Getting Template', type: 'error' }));
    } else {
      setDesignTemplatesData(response?.data?.data);
    }
  } catch (e: any) {
    setError(true);
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}

/**
 * Returns true only when the template was actually saved. Existing callers
 * ignore the return value, so their behaviour is unchanged; the redesigned
 * Edit screen uses it so it does not report success after a failed request.
 */
async function editDesignTemplates(
  oauthTokenHeader: any,
  data: any,
  templateUid: any
): Promise<boolean> {
  try {
    const response = await templateService.editTemplate(
      oauthTokenHeader,
      data,
      templateUid
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while Editing Template",
          type: "error",
        })
      );
      return false;
    }
    return true;
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    return false;
  }
}

/**
 * Fetches the template as it stood at a single revision. Feeds the "This
 * revision" side of the Edit screen's compare view.
 */
async function getDesignTemplateRevision(
  oauthTokenHeader: string,
  templateUid: string,
  revisionUid: string
): Promise<any | null> {
  try {
    const response = await templateService.getTemplateRevision(
      oauthTokenHeader,
      templateUid,
      revisionUid
    );
    if (!response.status || response.status !== 200) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "Something went wrong while loading the revision",
          type: "error",
        })
      );
      return null;
    }
    return response?.data?.data ?? null;
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
    return null;
  }
}

export const DesignTemplatesEndPointLogic = {
  getDesignTemplates,
  getDesignTemplatesTheme,
  createDesignTemplates,
  getWidgetStructures,
  getSingleDesignTemplate,
  editDesignTemplates,
  getDesignTemplateRevision,
  getLabels,
};
